import React from 'react';
import { Button } from '../components/ui/button';
import { showToast } from '../utils/helpers';
import { Header } from '../components/header';

const TestToast = () => {
  const handleSuccessToast = () => {
    showToast('success', 'This is a success toast message');
  };

  const handleErrorToast = () => {
    showToast('error', 'This is an error toast message');
  };

  const handleInfoToast = () => {
    showToast('info', 'This is an info toast message');
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header title="Toast Test" showBackButton={true} backTo="/" />
      <div className="flex-1 p-4 flex flex-col gap-4 items-center justify-center">
        <h1 className="text-2xl font-bold mb-4">Toast Notification Test</h1>
        <Button onClick={handleSuccessToast} className="w-full max-w-xs">
          Show Success Toast
        </Button>
        <Button onClick={handleErrorToast} className="w-full max-w-xs" variant="destructive">
          Show Error Toast
        </Button>
        <Button onClick={handleInfoToast} className="w-full max-w-xs" variant="outline">
          Show Info Toast
        </Button>
      </div>
    </div>
  );
};

export default TestToast;